import { fontWeight } from "@material-ui/system";

let styles = {
  lawVersion: {
    flex: 1,
    textAlign: "justify",
    fontSize: "1.2rem",
  },
  votingButtonsContainer: {
    marginTop: 10,
    marginBottom: 25,
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
  },
};

export default styles;
